module.exports = __webpack_public_path__ + "img/img11.3033ba11.jpg";